/* eslint-disable */
// Community-wide settings API client — thin web wrappers around the
// admin-managed feature flags at `/api/community-settings`. Mirrors
// `mobile/src/api/community.ts`.
//
// Contract (backend/app/api/community_settings.py):
//   GET   /api/community-settings  → any signed-in user; returns every
//         registered bool flag, e.g. { resident_live_guard_map: false }.
//   PATCH /api/community-settings  → ADMIN only; body is a partial set of
//         flags; returns the full updated flag map. RBAC is enforced
//         server-side (403 for non-admins).
import { apiFetch } from "../auth/apiClient";

export function getCommunitySettings() {
  return apiFetch("/api/community-settings", { authRequired: true });
}

export function updateCommunitySettings(body) {
  return apiFetch("/api/community-settings", {
    method: "PATCH",
    authRequired: true,
    body,
  });
}
